import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiUrl } from '../../utils/environment';
import { setUser } from './authSlice';

const initialState = {
    children: [],
    spouses: [],
    guest: [],
    streams: [],
    announcements: [],
    reminders: [],
    appointments: [],
    bookings: [],
    churches: [],
    info: {
        children: '',
        spouses: '',
        guest: '',
        streams: '',
        announcements: '',
        reminders: '',
        appointments: '',
        bookings: '',
        churches: '',
    },
    err: {
        children: null,
        spouses: null,
        guest: null,
        streams: null,
        announcements: null,
        reminders: null,
        appointments: null,
        bookings: null,
        churches: null,
    },
    busy: {
        children: false,
        spouses: false,
        guest: false,
        streams: false,
        announcements: false,
        reminders: false,
        appointments: false,
        bookings: false,
        churches: false,
    },
};

const listSlice = createSlice({
    name: 'list2',
    initialState,
    reducers: {
        setBusy: (state, action) => {
            const { status, list } = action.payload;
            state.busy[list] = status;
        },
        setError: (state, action) => {
            const { error, list } = action.payload;
            state.err[list] = error;
        },
        setList(state, action) {
            const { list, data } = action.payload;
            state[list] = data;
        },
    },
});

export const { setBusy, setList, setError } = listSlice.actions;

export const rtGetListData = (fetch, list, noAuth) => {
    return async (dispatch, getState) => {
        const auth = getState().auth.token;

        dispatch(setBusy({ status: true, list }));

        if (!auth && !noAuth) {
            dispatch(setBusy({ status: false, list }));
            return;
        }

        const config = {
            headers: { Authorization: `Bearer ${auth}` },
        };

        try {
            const response = await axios.get(
                `${apiUrl}/${fetch}`,
                noAuth ? {} : config
            );

            // eslint-disable-next-line no-console
            console.log('listSlice', response.status);

            response.status === 401 && dispatch(setUser({}));

            dispatch(setList({ list, data: response?.data?.data }));
            dispatch(setBusy({ status: false, list }));
        } catch (error) {
            const err = error?.response?.data;
            dispatch(setError({ error: err, list }));
            dispatch(setBusy({ status: false, list }));
        }
    };
};

export default listSlice.reducer;
